<template>
  <router-link to='/dashboard'>
    <img src="/static/logo2.png" class="logo__img">
  </router-link>
</template>

<script>
  export default { name: 'logotype' }
</script>

<style scoped lang="scss">
  @import "~scss/mixins";
  @import "~scss/variables";

  .logo__img {
    width: 188px;
    height: 60px;

    @include respond-to(small) {
      width: 120px;
      height: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/common/Logotype.vue